import { useTheme } from "styled-components";
import { ProgressRing, ProgressRingContainer } from "./styles";

const CircularProgressRing = ({
  radius,
  stroke,
  current,
  total,
  showNumber = false,
}) => {
  const theme = useTheme() as { [key: string]: { [key: string]: string } };
  const percentageProgress = (current / total) * 100 || 0; // Calculate the percentage progress

  const normalizedProgress = Math.min(Math.max(percentageProgress, 0), 100); // Ensure the value is between 0 and 100
  const circumference = 2 * Math.PI * radius;
  const progressOffset = ((100 - normalizedProgress) / 100) * circumference;

  const ringStyle = {
    strokeDasharray: `${circumference} ${circumference}`,
    strokeDashoffset: progressOffset,
  };

  return (
    <ProgressRingContainer>
      <span></span>
      <ProgressRing height={radius * 2} width={radius * 2}>
        <circle
          className="ring-background"
          stroke="#e5e5e5" // Change the color as needed
          strokeWidth={stroke}
          fill="transparent"
          r={radius - stroke / 2}
          cx={radius}
          cy={radius}
        />
        <circle
          className="progress"
          style={ringStyle}
          stroke="#e5e5e5" // Change the color as needed
          strokeWidth={stroke}
          fill="transparent"
          r={radius - stroke / 2}
          cx={radius}
          cy={radius}
        />
      </ProgressRing>
    </ProgressRingContainer>
  );
};

export default CircularProgressRing;
